/**
 * AndVScatter - 散点图组件
 * 基于 Ant Design Charts Scatter
 */
import React from 'react';
import { Scatter } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVScatterProps } from '../base/types';

const DEFAULT_SCATTER_DATA = [
  { x: 10, y: 20, category: 'A', size: 12 },
  { x: 15, y: 35, category: 'A', size: 18 },
  { x: 22, y: 28, category: 'B', size: 14 },
  { x: 30, y: 45, category: 'B', size: 22 },
  { x: 38, y: 32, category: 'C', size: 16 },
  { x: 45, y: 50, category: 'C', size: 24 },
];

const ScatterWithBase = withBaseChart<AndVScatterProps>(Scatter, {
  chartType: 'AndVScatter',
  defaultHeight: 300,
  defaultData: DEFAULT_SCATTER_DATA,
});

export const AndVScatter: React.FC<AndVScatterProps> = (props) => {
  const {
    xField = 'x',
    yField = 'y',
    sizeField,
    colorField,
    shapeField,
    seriesField,
    transpose,
    line,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    xField,
    yField,
  };

  if (sizeField) chartProps.sizeField = sizeField;
  if (colorField) chartProps.colorField = colorField;
  if (shapeField) chartProps.shapeField = shapeField;
  if (seriesField) chartProps.seriesField = seriesField;
  if (transpose !== undefined) chartProps.transpose = transpose;

  const lineConfig = parseJsonProp(line);
  if (lineConfig !== undefined) chartProps.line = lineConfig;

  return <ScatterWithBase {...chartProps} />;
};

export type { AndVScatterProps };
export default AndVScatter;
